import React, { Component, Fragment } from "react";
import { withRouter } from "react-router-dom";
import propTypes from "prop-types";
import { withCookies } from "react-cookie";

import Loading from "../../Components/Loading";
import ScheduleItem from "./_item";
import ApiClient from "../../Client";
import DateFormat from "../../helpers/DateFormat";
import ObjectHelper from "../../helpers/ObjectHelper";

class ScheduleList extends Component {
  static propTypes = {
    theatreId: propTypes.string.isRequired,
    dateBegin: propTypes.object.isRequired,
    dateEnd: propTypes.object.isRequired,
    canBeDelete: propTypes.bool.isRequired
  };

  state = {
    rows: null,
    isFetched: false,
    isFetching: false,
    sort: ["film.title", true]
  };

  getAuthCookie() {
    const { cookies } = this.props;
    return cookies.get(process.env.REACT_APP_IDENTITY_COOKIE) || "";
  }

  fetchList() {
    const { dateBegin, dateEnd, theatreId } = this.props;
    return ApiClient.setHeader("authKey", this.getAuthCookie()).request(
      `query($begin:Int! $end:Int! $theatreId: ID!) { 
        schedules(where:{
          theatre: { id: $theatreId },
          OR:[
            { dateBegin_lt: $begin, dateEnd_gt: $begin},
            { dateBegin_gte: $begin, dateEnd_lte: $end},
            { dateBegin_lt: $end, dateEnd_gt: $end},
          ]
        }) {
           id 
           times 
           dateBegin 
           dateEnd 
           format
           film{
             id
             title
            } 
           theatre{
             id
             name
            } 
          } 
      }`,
      {
        begin: DateFormat.getEpoch(dateBegin),
        end: DateFormat.getEpoch(dateEnd),
        theatreId
      }
    );
  }

  componentWillUnmount() {
    this.isCancelled = true;
  }

  componentDidUpdate(prevProps) {
    const { theatreId, dateBegin, dateEnd } = this.props;
    if (
      theatreId !== prevProps.theatreId ||
      dateBegin !== prevProps.dateBegin ||
      dateEnd !== prevProps.dateEnd
    ) {
      const { isFetched, isFetching } = this.state;

      if (!(isFetching && isFetched)) {
        !this.isCancelled &&
          this.setState({ isFetched: false, isFetching: true });
        !this.isCancelled &&
          this.fetchList()
            .then(({ schedules }) =>
              schedules.map(({ film, theatre, ...schedule }) => ({
                film,
                theatre,
                ...schedule,
                filmId: (film && film.id) || null,
                theatreId: (theatre && theatre.id) || null
              }))
            )
            .then(
              rows =>
                !this.isCancelled &&
                this.setState({ rows, isFetched: true, isFetching: false })
            );
      }
    }
  }

  componentDidMount() {
    this.componentDidUpdate({});
  }

  setSort = name => {
    const sort = this.state.sort || [];
    if (sort[0] === name) {
      sort[1] = !sort[1];
    } else {
      sort[0] = name;
      sort[1] = true;
    }
    this.setState({ sort });
  };

  deleteAction = index => {
    const row = this.getRows()[index];
    if (row) {
      ApiClient.setHeader("authKey", this.getAuthCookie())
        .request(
          `mutation($id:ID!) { deleted:deleteSchedule(where:{id:$id}) {id} }`,
          { id: row.id }
        )
        .then(({ deleted }) => {
          if (deleted && deleted.id) {
            const rows = [...this.state.rows];
            rows.splice(index, 1);
            this.setState({ rows });
          }
        });
    }
  };

  getSortTitle(sortName, sortLabel) {
    const sort = this.state.sort || [];
    if (sort[0] !== sortName) {
      return <span>{sortLabel}</span>;
    }

    return (
      <Fragment>
        <span className="active">
          {sortLabel}
          &nbsp;
        </span>
        <img
          src={
            sort[1]
              ? "/images/icon-arrow-down-blue.png"
              : "/images/icon-arrow-up.png"
          }
          alt=""
        />
      </Fragment>
    );
  }

  getRows() {
    const {
      rows,
      sort: [sortAttr, sortAsc]
    } = this.state;

    const sort = sortAsc
      ? (a, b) => {
          if (ObjectHelper.get(a, sortAttr) > ObjectHelper.get(b, sortAttr)) {
            return 1;
          }
          if (ObjectHelper.get(a, sortAttr) < ObjectHelper.get(b, sortAttr)) {
            return -1;
          }
          return 0;
        }
      : (a, b) => {
          if (ObjectHelper.get(b, sortAttr) > ObjectHelper.get(a, sortAttr)) {
            return 1;
          }
          if (ObjectHelper.get(b, sortAttr) < ObjectHelper.get(a, sortAttr)) {
            return -1;
          }
          return 0;
        };
    return (rows || []).sort(sort);
  }

  renderListHead() {
    return (
      <thead>
        <tr>
          <td
            className="small-column filter-column"
            onClick={() => this.setSort("film.title")}
          >
            {this.getSortTitle("film.title", "Фильм")}
          </td>
          <td
            className="small-column filter-column"
            onClick={() => this.setSort("dateBegin")}
          >
            {this.getSortTitle("dateBegin", "Дата начала")}
          </td>
          <td
            className="small-column filter-column"
            onClick={() => this.setSort("dateEnd")}
          >
            {this.getSortTitle("dateEnd", "Дата окончания")}
          </td>
          <td
            className="large-column separator filter-column"
            onClick={() => this.setSort("times")}
          >
            {this.getSortTitle("times", "Время")}
          </td>
        </tr>
      </thead>
    );
  }

  render() {
    const { isFetched, isFetching } = this.state;
    const { canBeDelete } = this.props;
    if (!isFetched && isFetching) {
      return <Loading loading />;
    }
    return (
      <table className="office__table schedule-upload__table">
        {this.renderListHead()}
        <tfoot>
          <tr>
            <td colSpan="4" />
          </tr>
        </tfoot>
        <tbody>
          {this.getRows().map((element, index) => (
            <ScheduleItem
              key={`schedule-item-${index}`}
              index={index}
              {...element}
              deleteAction={this.deleteAction}
              canBeDelete={canBeDelete}
            />
          ))}
        </tbody>
      </table>
    );
  }
}
export default withCookies(withRouter(ScheduleList));



// WEBPACK FOOTER //
// ./src/containers/schedule/_list.jsx